<template>
  <header class="header">
    <div class="header-inner">
      <h1 class="logo">
        <a href="/"><img :src="logoSrc" alt="エムスリーキャリア" /></a>
      </h1>
    </div>
  </header>
</template>

<script>
export default {
  name: 'LpHeader',
  props: {
    logoSrc: { type: String, default: '' }
  }
}
</script>
